import React, { useMemo } from 'react';
import Link from '@mui/material/Link';
import SocialMediaAccounts from '@/constants/constituents/SocialMediaAccounts';
import useMobileView from '@/hooks/ui/useMobileView';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TiktokIcon,
  TwitterIcon,
  YouTubeIcon,
} from '@/lib/configs/donor-icons';
import { formatUrl } from '@/utils/urls';

const SocialAccountIcons = {
  [SocialMediaAccounts.FACEBOOK]: FacebookIcon,
  [SocialMediaAccounts.INSTAGRAM]: InstagramIcon,
  [SocialMediaAccounts.LINKEDIN]: LinkedInIcon,
  [SocialMediaAccounts.TWITTER]: TwitterIcon,
  [SocialMediaAccounts.YOUTUBE]: YouTubeIcon,
  [SocialMediaAccounts.TIKTOK]: TiktokIcon,
};

type SocialAccountsProps = {
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  twitter?: string;
  youtube?: string;
  tiktok?: string;
  className?: string;
};

function SocialAccounts({ className, ...data }: SocialAccountsProps) {
  const isMobile = useMobileView();
  const Accounts = useMemo(
    () =>
      Object.values(SocialMediaAccounts).map((account) => {
        // formatUrl makes sure that a link always contains http(s)
        const link = formatUrl(data[account]);

        if (link) {
          return (
            <Link
              data-testid={`social-account-${account}`}
              href={link}
              key={account}
              rel="noopener noreferrer"
              target="_blank"
              // This is a hacky workaround for existing use cases. We want to refactor
              // this out in the future.
              sx={{
                '& img': {
                  height: isMobile ? '36px' : '24px',
                  minHeight: isMobile ? '36px' : '24px',
                  width: isMobile ? '36px' : '24px',
                  minWidth: isMobile ? '36px' : '24px',
                },
              }}
            >
              {SocialAccountIcons[account]}
            </Link>
          );
        }

        return null;
      }),
    [data],
  );

  return <div className={className}>{Accounts}</div>;
}

export default SocialAccounts;
